import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import {
  IUpdatePriceRequest,
  IUpdatePriceResponse,
} from '../../models/warehouse/updatePrice.model';
import useHttps from '../useHttps';

const useUpdatePrice = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const onUpdatePriceError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const onUpdatePriceSuccess = ({
    message,
  }: SuccessHttpResponse<IUpdatePriceResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const updatePrice = (data: IUpdatePriceRequest) => {
    const url: HttpConfig = {
      url: `general-service/v1/prices/${data.priceId}?amount=${data.price}`,
      method: 'put',
    };

    request(url, onUpdatePriceSuccess, setLoading, onUpdatePriceError);
  };

  return { updatePrice, loading, resetInputFields };
};

export default useUpdatePrice;
